import { render, staticRenderFns } from "./CornerSprite.vue?vue&type=template&id=3535f135&scoped=true"
import script from "./CornerSprite.vue?vue&type=script&lang=js"
export * from "./CornerSprite.vue?vue&type=script&lang=js"
import style0 from "./CornerSprite.vue?vue&type=style&index=0&id=3535f135&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535f135",
  null
  
)

export default component.exports